import { c as _c } from "react/compiler-runtime";
import Image from "@/components/common/image/image";
interface ContactInfoProps {
  phone?: string;
  email?: string;
}
const ContactInfo = t0 => {
  const $ = _c(7);
  const {
    phone,
    email
  } = t0;
  let t1;
  if ($[0] !== phone) {
    t1 = phone && <p className="mb-2 flex items-center gap-2 text-[18px] leading-7 font-medium text-black"><Image src="/phone.svg" alt="Phone icon" className="h-5 w-5 object-contain" width={24} height={24} /><a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="transition-colors hover:text-[#00698F]">{phone}</a></p>;
    $[0] = phone;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== email) {
    t2 = email && <p className="mb-2 flex items-center gap-2 text-[18px] leading-7 font-medium text-black"><Image src="/email.svg" alt="Email icon" className="h-5 w-5 object-contain" width={24} height={24} /><a href={`mailto:${email}`} className="transition-colors hover:text-[#00698F]">{email}</a></p>;
    $[2] = email;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ContactInfo;